export default __webpack_public_path__ + "static/media/InvalidScanner.62cfbdb3.png";